import { useState } from "react";
import { money, x2, num, roasTone } from "./roasUtil";

const COLS = [["name", "Name"], ["spend", "Spend"], ["impressions", "Impr."], ["ctr_pct", "CTR"], ["meta_leads", "Meta leads"], ["leads", "CRM leads"],
  ["cpl", "CPL"], ["won", "Won"], ["revenue", "Sales"], ["roas", "ROAS"], ["cac", "Cost/client"]];

function cell(k, r) {
  if (k === "name") return null;
  if (["spend", "cpl", "revenue", "cac"].includes(k)) return money(r[k]);
  if (k === "roas") return <span className={`font-medium ${roasTone(r.roas, r.target_roas)}`}>{x2(r.roas)}</span>;
  if (k === "ctr_pct") return r.ctr_pct != null ? `${r.ctr_pct}%` : "\u2014";
  return num(r[k]);
}

export function RoasTables({ d, picked, onToggle }) {
  const [tab, setTab] = useState("campaigns");
  const [sort, setSort] = useState(["spend", -1]);
  const src = tab === "campaigns" ? d.campaigns : d.ads;
  const rows = [...src].sort((a, b) => {
    const [k, dir] = sort;
    const av = a[k] ?? -Infinity, bv = b[k] ?? -Infinity;
    return (typeof av === "string" ? av.localeCompare(bv) : av - bv) * dir;
  });
  const idk = tab === "campaigns" ? "campaign_id" : "ad_id";
  return (
    <section className="panel p-4 overflow-x-auto" data-testid="roas-tables">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        {[["campaigns", "By campaign"], ["ads", "By ad"]].map(([k, l]) => <button key={k} className={`text-sm ${tab === k ? "font-medium" : "text-[var(--text-dim)]"}`} onClick={() => setTab(k)} data-testid={`roas-tab-${k}`}>{l}</button>)}
      </div>
      {tab === "campaigns" && <div className="text-xs text-[var(--text-dim)] mb-2">Tick campaigns to narrow the whole report to them. Untick all to see everything.</div>}
      <table className="w-full text-xs tabular-nums min-w-[900px]">
        <thead className="text-[var(--text-dim)] text-left">
          <tr>
            {tab === "campaigns" && <th className="w-6" />}
            {COLS.map(([k, l]) => (
              <th key={k} className="py-1.5 pr-3 font-normal cursor-pointer select-none hover:text-[var(--text)]" onClick={() => setSort([k, sort[0] === k ? -sort[1] : k === "name" ? 1 : -1])} data-testid={`roas-sort-${k}`}>
                {l}{sort[0] === k ? (sort[1] < 0 ? " \u2193" : " \u2191") : ""}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r[idk]} className="border-t border-[var(--border)]" data-testid={`roas-row-${r[idk]}`}>
              {tab === "campaigns" && <td><input type="checkbox" checked={picked.includes(r.campaign_id)} onChange={() => onToggle(r.campaign_id)} data-testid={`roas-row-pick-${r.campaign_id}`} /></td>}
              <td className="py-1.5 pr-3 max-w-[320px]">
                <div className="truncate" title={r.name}>{r.name || r[idk]}</div>
                <div className="text-[10px] text-[var(--text-faint)] truncate">{tab === "campaigns" ? `${r.account || ""} · ${(r.status || "").toLowerCase()}` : r.campaign}</div>
              </td>
              {COLS.slice(1).map(([k]) => <td key={k} className="pr-3">{cell(k, r)}</td>)}
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={12} className="py-4 text-[var(--text-dim)]">No ad activity in this range.</td></tr>}
        </tbody>
      </table>
    </section>
  );
}
